module.exports = __webpack_public_path__ + "img/tp-building.ed2682f0.jpg";